<template>
  <div class="nav-bar">
    <v-app-bar app flat elevate-on-scroll fixed>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title class="grey--text">
        <img :src="`data:image/png;base64,${logoPrefeitura}`" alt height="50" />
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-xs-only">
        <v-btn small text v-for="link in links" :key="link.text" router :to="link.route">
          <span>{{ link.text }}</span>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn small text v-on="on">
              Consultas
              <v-icon small right>keyboard_arrow_down</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-for="(item, index) in items" :key="index" router :to="item.route">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

<!--      <v-btn v-if="opcoesCadastro.length === 1"-->
<!--          small-->
<!--        outlined-->
<!--        color="primary"-->
<!--        class="mx-2 hidden-xs-only"-->
<!--        v-on:click="abrePopUp()">-->
<!--        Cadastro-->
<!--      </v-btn>-->
      <v-menu offset-y class="menu-cadastro" v-if="habilitadoCardCadastro">
        <template v-slot:activator="{ on, attrs }">
          <v-btn outlined small color="primary"
                 v-bind="attrs"
                 v-on="on">
            <v-icon small left>mdi-arrow-down</v-icon>
            {{ botaoCardCadastro }}
          </v-btn>
        </template>
        <v-list class="pa-0">
          <v-list-item
              v-for="(item, index) in opcoesCadastro"
              :key="index">
            <v-list-item-title @click="abrePopUpUrl(item.url)">{{ item.opcao }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn depressed small dark color="primary" class="mx-2 hidden-xs-only" route :to="linkLogin">
        <v-icon small left>exit_to_app</v-icon>
        {{ botaoCardEntrar }}
      </v-btn>
      <v-btn depressed small dark color="primary" class="mx-2 hidden-xs-only" route @click="redirecionaPaginaNotaAvulsa" v-if="habilitaLinkNotaAvulsa">
        Acessar Nota Fiscal Avulsa
      </v-btn>
    </v-app-bar>

    <v-navigation-drawer app temporary v-model="drawer" color="primary">
      <v-list>
        <v-list-item v-for="link in linksDrawer" v-show="link.show" :key="link.text" router :to="link.route">
          <v-list-item-icon>
            <v-icon class="white--text">{{ link.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="white--text">
            {{ link.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    logoPrefeitura: {
      type: String,
    },
    habilitaLinkNotaAvulsa: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaFisica: {
      type: Boolean,
    },
    habilitadoAutenticacaoPessoaJuridica: {
      type: Boolean,
    },
    urlCadastroPessoaFisica: {
      type: String,
    },
    urlCadastroPessoaJuridica: {
      type: String,
    },
    permiteRedefinicaoEmail: {
      type: Boolean,
    },
    botaoCardCadastro: {
      type: String,
    },
    botaoCardEntrar: {
      type: String,
    },
    habilitadoCardPrimeiroAcesso: {
      type: Boolean,
    },
    habilitadoCardCadastro: {
      type: Boolean,
    },
  },
  name: "Navbar",
  mounted() {
    // if (this.habilitadoAutenticacaoPessoaFisica)
      this.opcoesCadastro.push({"opcao": "Pessoa Física", "url": this.urlCadastroPessoaFisica});

    // if (this.habilitadoAutenticacaoPessoaJuridica)
      this.opcoesCadastro.push({"opcao": "Pessoa Jurídica", "url": this.urlCadastroPessoaJuridica});

    if (!this.permiteRedefinicaoEmail)
      this.linksDrawer = this.linksDrawer.filter(l => l['route'] !== "/recuperarEmail")

  },
  data() {
    return {
      opcoesCadastro: [],
      drawer: false,
      linkLogin: "/login",
      linkNotaAvulsa: window.location.origin.concat("/notafiscal/paginas/portal-avulsa"),
      items: [
        { icon: "done_all", text: "Autenticidade", route: "/autenticidade" },
        { icon: "folder", text: "Legislação", route: "/legislacao" },
        { icon: "folder", text: "Documentação API", route: "/api" },
        {
          icon: "folder",
          text: "Empresas autorizadas à emissão",
          route: "/empresa",
        },
        {
          icon: "folder",
          text: "Tabela de atividades",
          route: "/tabela",
        },
        {
          icon: "folder",
          text: "Substituto Tributário",
          route: "/substitutoTributario",
        }
      ],
      linkCredenciamento: "/credenciamento",
      linksDrawer: [
        { icon: "home", text: "Inicial", show: true, route: "/" },
        { icon: "account_circle", text: "Acessar", show: true, route: "/login" },
        { icon: "lock", text: "Recuperar senha", show: this.habilitadoCardPrimeiroAcesso, route: {name: "SolicitarSenha", params: { cpf: this.habilitadoAutenticacaoPessoaFisica, cnpj: this.habilitadoAutenticacaoPessoaJuridica}} },
        { icon: "history", text: "Recuperar Email", show: true, route: "/recuperarEmail" },
        { icon: "folder", text: "Legislação", show: true, route: "/legislacao" },
        { icon: "live_help", text: "Ajuda", show: true, route: "/ajuda" },
        { icon: "question_answer", text: "Fale Conosco", show: true, route: "/contato" },
        {
          icon: "account_balance",
          text: "Empresas autorizadas",
          route: "/empresa",
        },
      ],
      links: [
        { icon: "home", text: "Inicial", route: "/" },
        { icon: "live_help", text: "Ajuda", route: "/ajuda" },
        { icon: "question_answer", text: "Fale Conosco", route: "/contato" },
      ],
    };
  },
  methods: {
    redirecionaPaginaNotaAvulsa() {
      window.location.href = this.linkNotaAvulsa;
    },
    abrePopUp() {
      let url = this.habilitadoAutenticacaoPessoaFisica ? this.urlCadastroPessoaFisica : this.urlCadastroPessoaJuridica;
      this.abrePopUpUrl(url)
    },
    abrePopUpUrl(url) {
      window.open(url, 'Pagina', 'resizable=0,WIDTH=1024, HEIGHT=640')
    }
  }
};
</script>
